import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IDateCalculateBehavior } from "../../../../documaker/domain/format/objects";

export interface IDataCalculateBehaviorPropertyEditable {
  dateCalculateBehavior(): IPropertyEditable<IDateCalculateBehavior>;
}

export function instanceOfIDataCalculateBehaviorPropertyEditable(instance: any): instance is IDataCalculateBehaviorPropertyEditable {
  return instance
    && instance.dateCalculateBehavior
    && instanceOfIPropertyEditable<IDateCalculateBehavior>(instance.dateCalculateBehavior());
}
